export const API_ERROR_CODES = {
  FEATURE_LOCKED: 'feature_locked',
  IDEMPOTENCY_CONFLICT: 'idempotency_conflict',
  LIMIT_REACHED: 'limit_reached',
} as const;

export const API_ERROR_MESSAGES = {
  FEATURE_LOCKED_MESSAGE: 'user does not have permission to use this tool',
  POLICY_FEATURE_LOCKED: 'policyengine: feature locked',
  POLICY_IDEMPOTENCY_CONFLICT: 'policyengine: idempotency conflict',
  POLICY_INSUFFICIENT_BALANCE: 'policyengine: insufficient balance',
  SUBSCRIPTION_IS_CANCELED: 'Subscription is canceled',
  WORDS_LIMIT_EXCEEDED: 'words limit exceeded',
} as const;

export const STREAM_ERROR_FALLBACK_MESSAGES = {
  INVALID_STREAM_RESPONSE: 'Invalid stream response',
  NO_EVENT_DATA_EVENT_TYPE: 'no event data event_type',
} as const;

type ApiErrorPayload = {
  code?: string;
  error?: string;
  fields?: Record<string, unknown>;
  message?: string;
};

export const isWordsLimitErrorPayload = (payload: ApiErrorPayload): boolean => {
  const fieldsCode = payload.fields?.code;
  const fieldsMessage = payload.fields?.message;

  return (
    payload.code === API_ERROR_CODES.LIMIT_REACHED ||
    fieldsCode === API_ERROR_CODES.LIMIT_REACHED ||
    fieldsMessage === API_ERROR_MESSAGES.WORDS_LIMIT_EXCEEDED ||
    payload.error === API_ERROR_MESSAGES.WORDS_LIMIT_EXCEEDED ||
    payload.error === API_ERROR_MESSAGES.POLICY_INSUFFICIENT_BALANCE
  );
};
